/*
 * @Description: 首页
 * @Autor: xiaona.wang
 * @Date: 2021-12-14 13:57:53
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-07-18 16:31:45
 */
import request from "@/utils/request";
const requestUrl = `${window.env.equipmentService}/api/v1`;
const baseUrl = `${window.env.basicService}/api/v1`;
const { scimSystem } = window.env;
const api = {
  getDeviceBranch: () => request({
    url: `${requestUrl}/equipment-info/location/analysis`,
    method: "post"
  }),
  getWarnStatisticAnalysish: params => request({
    url: `${requestUrl}/alarm-message-statistics/count/analysis`,
    method: "get",
    params
  }),
  // 备件消耗资金top10
  getPartConsumeMoneyTop10: params => request({
    url: `${baseUrl}/output-records/cost/analysis`,
    method: "get",
    params
  }),
  // 设备oeeTop10
  getDeviceOeeTop10: params => request({
    url: `${requestUrl}/equipment-run-log/running-rate/analysis`,
    method: "get",
    params
  }),
  // 设备役龄占比
  getDeviceWorkingAgeRate: params => request({
    url: `${requestUrl}/equipment-info/purchase/analysis`,
    method: "post",
    params
  }),
  // 资产总值(万元)
  getAssetsTotal: params => request({
    url: `${requestUrl}/equipment-info/capital/analysis`,
    method: "get",
    params
  }),
  // 备件使用数量TOP10
  getPartUsedNumberTop10: params => request({
    url: `${baseUrl}/output-records/quantity/analysis`,
    method: "get",
    params
  }),
  // 工单类型占比
  getOrderTypeRate: params => request({
    url: `${requestUrl}/order/order-type-rate/analysis`,
    method: "get",
    params
  }),
  // 工单统计分析
  getOrderStatisticAnalysis: params => request({
    url: `${requestUrl}/order/order-statistics/analysis`,
    method: "get",
    params
  }),
  // 工单完成率
  getOrderCompleteRate: params => request({
    url: `${requestUrl}/order/finish/analysis`,
    method: "get",
    params
  }),
  // 今日工单统计
  getTodayOrderStatistic: () => request({
    url: `${requestUrl}/order/order/status-count/-statistics/analysis`,
    method: "get"
  }),
  // 今日预警统计
  getTodayWarnStatistic: params => request({
    url: `${requestUrl}/alarm-message-statistics/count/${params}/analysis`,
    method: "get"
  }),
  // 平均故障修复时间排行(MTTR)TOP10
  getAverageFaultTop10: params => request({
    url: `${requestUrl}/equipment-info/evaluation-info-statistics/analysis`,
    method: "get",
    params
  }),
  // 保存配置
  homeConfigSave: data => request({
    url: `${scimSystem}/api/v1/user/layout-config`,
    method: "post",
    data
  }),
  // 获取配置
  getHomeConfig: params => request({
    url: `${scimSystem}/api/v1/user/layout-config`,
    method: "get",
    params
  }),
  // 通过角色id获取菜单
  getMenuByRoleId: data => request({
    // url: `${scimSystem}/api/v1/menus/query-by-roles?parseToTree=true&clientType=WEB`,
    url: `${scimSystem}/api/v1/current-user/menus?parseToTree=true&clientType=WEB`,
    method: "get",
    data
  })
};
export default api;
